import React, {useEffect, useState} from 'react'
import clsx from "clsx";

import useTextContents from '../../hooks/useTextContents'
import {ReactComponent as FailedIcon} from '../../icons/svg/fail-page-icon.svg'
import {ILeadSaleBannerModel} from './models/IFailPageModel'
import {LeadStatisticEventType} from '../../service/LoanInitService'
import PageScreen from "../../components/organisms/Page/PageScreen"
import Paragraph from "../../components/atoms/Paragraph/Paragraph"
import AppLink from "../../components/atoms/AppLink/AppLink"
import {AppFrame} from "../../components/atoms/AppFrame/AppFrame"
import PageHeader from "../../components/atoms/PageHeader/PageHeader"
import {HEADER_LEVEL} from "../../components/atoms/PageHeader/PageHeaderProps"
import useFailPageLogic from "./hooks/useFailPageLogic"
import { APP_COLOR, APP_FONT_SIZE } from '../../components/atoms/AtomsGlobalProps'
import WaitingScreen from '../WaitingScreens/WaitingScreenPage'

import './FailPage.scss'

/**
 * Dodatkowy baner z przyciskiem oraz logiką przekierowania klienta na stronę lead'a.
 * Pojawia się jedynie w momencie gdy dla danego partnera uda się wygenerować poprawny link.
 * @returns
 */
const LeadSaleBanner = (props: ILeadSaleBannerModel) => {
    const { leadRedirectionSecondsLeft, leadSaleRedirectionUrl, addLeadStatisticRecord, textContent } = props


    return (
        // <div className='fail-page-lead-banner-outer-wrapper'>
        <AppFrame className={clsx("fail-page-bold-frame")}>

            <div className={"fail-page-bold-frame-container"}>
                <PageHeader
                    level={HEADER_LEVEL.H4}
                    title={textContent('failPage.leadSaleBannerMainText')}>

                </PageHeader>
                <AppLink
                    href={leadSaleRedirectionUrl} 
                    align='center' externalCard size={APP_FONT_SIZE.LARGE} 
                    onClick={() => addLeadStatisticRecord(LeadStatisticEventType.CLICK)}
                >
                    {textContent('failPage.leadSaleBannerButtonText')}
                </AppLink>
                <Paragraph size={APP_FONT_SIZE.EXTRA_SMALL} color={APP_COLOR.GRAY} align={"center"}>
                    {`${textContent('failPage.leadSaleBannerTipText')}: ${ leadRedirectionSecondsLeft } s`}
                </Paragraph>
            </div>
        </AppFrame>
    )
}

/**
 * Komponent wyświetlający stronę z negatywną decyzją w dwóch wersjach - dla lead'a albo normalnej.
 * @returns
 */
const FailPage = () => {
    const textContent = useTextContents()
    const { leadRedirectionSecondsLeft, leadSaleLink, isInitializing, addLeadStatisticRecord } = useFailPageLogic()


    if(isInitializing) {
        return <WaitingScreen />
    }

    return (
        <PageScreen
            title={{title: textContent('failPage.heading'), line: false}}
            icon={{icon: FailedIcon, label: 'Fail icon'}}
            showBackButton={false}>

            <div className='fail-page-container'>
                <div className='fail-page-description'>
                    <Paragraph>{textContent('failPage.mainContentTextUp')}</Paragraph>
                    <Paragraph>{textContent('failPage.mainContentTextDown')}</Paragraph>
                </div>
                {
                    leadSaleLink === null ?
                    <Paragraph color={APP_COLOR.GRAY} size={APP_FONT_SIZE.SMALL}>{textContent('failPage.tip')}</Paragraph>
                    :
                    <LeadSaleBanner
                        textContent={textContent}
                        leadSaleRedirectionUrl={leadSaleLink}
                        leadRedirectionSecondsLeft={leadRedirectionSecondsLeft}
                        addLeadStatisticRecord={addLeadStatisticRecord}
                    />
                }
            </div>
        </PageScreen>
    )
}

export default FailPage;